const config = {
    apiBaseUrl: process.env.NODE_ENV === 'production'
        ? 'https://clients.durej.com/api'
        : 'http://localhost:8000/api'
};

export default config; 